import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'

import getHomeRoute from '@/shared/PersonaHomeRoute/HomeRoute'
import { userState } from '@/shared/state/user/user'

type LocalStorageItems = {
  [key: string]: string
}

export function useUserRedirect() {
  const { pathname } = useLocation()
  const [userRecoilState] = useRecoilState(userState)
  const isPathCorrectUser =
    pathname.includes('clinic') ||
    pathname.includes(userRecoilState.personaType.toLowerCase())
  const navigate = useNavigate()

  useEffect(() => {
    const checkLocalStorageItems = (itemNames: string[]): LocalStorageItems => {
      return itemNames.reduce((acc: LocalStorageItems, itemName: string) => {
        const item = localStorage.getItem(itemName)
        if (item) {
          acc[itemName] = item
        } else {
          acc[itemName] = ''
        }
        return acc
      }, {})
    }
    const localStorageValues = checkLocalStorageItems(['ea-user', 'ea-persona'])
    if (localStorageValues['ea-user'] && localStorageValues['ea-persona']) {
      if (!isPathCorrectUser) {
        navigate(getHomeRoute(userRecoilState.personaType))
      }
    }
  }, [])
}
